import { useEffect } from 'react';

// Shared page-scroll lock for popups.
//
// Each popup used to save body.style.overflow, set it to "hidden", and restore the
// saved value on close. When two popups overlap (AuthModal is still open when
// OnboardingModal opens), the second one saves "hidden" and later "restores" it,
// so the page stays locked. Counting open popups fixes that: scroll is locked while
// at least one is open, and unlocked when the last one closes.

let openCount = 0;
let savedOverflow = '';

export function lockScroll() {
  if (openCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  openCount += 1;

  let released = false;
  return function unlock() {
    if (released) return;
    released = true;
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) document.body.style.overflow = savedOverflow;
  };
}

/** Lock page scroll while the calling component is mounted. */
export function useScrollLock() {
  useEffect(() => lockScroll(), []);
}
